module.exports = __webpack_public_path__ + "img/5.e4099539.png";